import { Gender } from '../tools/RetirementCalculator.const';
import { LIFE_EXPECTANCY_MONTHS } from './lifeExpectancy.data';
import { ZUS_ACCOUNT_BALANCES } from './zusAccountBalances.data';
import { ZUS_SUBACCOUNT_BALANCES } from './zusSubaccountBalances.data';
import { ZusBalanceRowModel } from './zusData.model';

const findBalanceRow = (rows: ZusBalanceRowModel[], birthYear: number): ZusBalanceRowModel => {
  const [first] = rows;
  const last = rows[rows.length - 1];

  if (birthYear <= first.birthYear) {
    return first;
  }
  if (birthYear >= last.birthYear) {
    return last;
  }

  return [...rows].reverse().find(row => row.birthYear <= birthYear) ?? last;
};

const getBalance = (rows: ZusBalanceRowModel[], birthYear: number, gender: Gender) => {
  const row = findBalanceRow(rows, birthYear);
  return gender === Gender.FEMALE ? row.female : row.male;
};

export const getZusAccountBalance = (birthYear: number, gender: Gender) =>
  getBalance(ZUS_ACCOUNT_BALANCES, birthYear, gender);

export const getZusSubaccountBalance = (birthYear: number, gender: Gender) =>
  getBalance(ZUS_SUBACCOUNT_BALANCES, birthYear, gender);

export const getZusAccumulatedCapital = (birthYear: number, gender: Gender) =>
  getZusAccountBalance(birthYear, gender) + getZusSubaccountBalance(birthYear, gender);

const LIFE_EXPECTANCY_AGES = Object.keys(LIFE_EXPECTANCY_MONTHS)
  .map(Number)
  .sort((a, b) => a - b);

export const getLifeExpectancyMonths = (age: number) => {
  const roundedAge = Math.round(age);
  const minAge = LIFE_EXPECTANCY_AGES[0];
  const maxAge = LIFE_EXPECTANCY_AGES[LIFE_EXPECTANCY_AGES.length - 1];
  const cappedAge = Math.min(Math.max(roundedAge, minAge), maxAge);

  return LIFE_EXPECTANCY_MONTHS[cappedAge] ?? LIFE_EXPECTANCY_MONTHS[maxAge];
};
